// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Dmkbu","col":"styles_col__BoIvj","actions":"styles_actions__3S-ZF","conflict":"styles_conflict__1Xv3j"};